import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components'
import {AddIcon} from 'components/static/icons'
import Color from 'constants/colors'

import AnnotationRead from 'components/interactive/annotation/AnnotationRead';
import AnnotationEdit from 'components/interactive/annotation/AnnotationEdit';

//styles----
const Title = styled.h4`
  text-align: left;
`;

const CreateContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: ${props=>props.theme.fonts.h5};
  font-weight: bold;
  @media not all and (hover: none) {
    &:hover {
      cursor: pointer;
      color: ${Color('teal')};
    }
  }
`;

const CreateButton = styled.div`
  margin-left: 5px;
  width: 35px;
  height: 35px;
`

const AnnoContainer = styled.div`
  opacity: ${props=>props.opacity};
  transform: scale(${props=>props.scale});
  transition-property: opacity, transform;
  transition-duration: 150ms; 
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);

  box-sizing: border-box;
  background-color: WHITESMOKE;
  padding: 30px 35px;
  margin-top: 24px;
`;

const CreateComponents = styled.div`
  display: flex;
  justify-content: center;
`;
//---styles

class AnnotationsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreate: false,
      opacity: 0,
      scale: 0.97,
    };
  }

  componentDidMount() {
    this.setState({
      opacity:1,
      scale: 1,
    });
  }

  getAnnoData = (pageId, userId) => {
    const { annotations } = this.props;
    const key = `${pageId}#${userId}`;
    const annoData = annotations[key] || {};
    return annoData;
  }

  getAnnotations = (annoData, sectionId) => {
    if (!annoData || !annoData.data) {
      return [];
    }
    const sectionAnnotationData = annoData.data.filter((a) => {
      return a.sectionId === sectionId;
    });
    return sectionAnnotationData;
  }

  // getVotePref = (props) => {
  //   const { votePrefs, pageId, userId } = this.props;
  //   const key = `${pageId}#${userId}`;
  //   const votePref = votePrefs[key] || { data: {} };
  //   return votePref;
  // }

  handleCreate = (e) => {
    this.setState({
      showCreate: !this.state.showCreate
    });
  }

  render() {
    const { user, pageId, loggedInUserId, authorUserId, sectionId } = this.props;
    const userId = (authorUserId || loggedInUserId);
    // is userId in store === URL userId param? is userId is store === passed down loggedInUserId, but not undefined===undefined 
    const viewerIsOwner = (loggedInUserId === authorUserId) || ((loggedInUserId === user.userId) && loggedInUserId);
    const annoData = this.getAnnoData(pageId, userId);
    let nameToDisplay = user.first ? user.first +"'s" : "my";
    if(authorUserId && (loggedInUserId !== authorUserId)) { 
      // only case where we need to show the name of the author, rather than the viewer
      nameToDisplay = (annoData.user ? annoData.user.name+".'s" : "");
    }// else can default to viewer name

    const annotations = this.getAnnotations(annoData, sectionId);
    const annotationBlock = annotations.map((a) => {
      return (
        <AnnotationRead
          key={`annotation-${a.id}`}
          pageId={pageId}
          userId={userId}
          sectionId={sectionId}
          annotationId={a.id}
          text={a.text}
          userName={nameToDisplay}
          createdAt={a.createdAt}
          updatedAt={a.updatedAt}
        />
      );
    });

    let createComponents = null;
    if (this.state.showCreate) {
      createComponents = (
        <AnnotationEdit
          pageId={pageId} 
          userId={userId}
          sectionId={sectionId} 
          onCancel={this.handleCreate}
        />
      );
    } else if (viewerIsOwner) {
      createComponents = (
        <CreateContainer onClick={this.handleCreate}>
          Add a note
          <CreateButton><AddIcon color={Color('teal')}/></CreateButton>
        </CreateContainer>
      );
    }

    const {opacity, scale} = this.state;
    return (
      <AnnoContainer opacity={opacity} scale={scale}>
        {annotationBlock.length > 0 && 
          <Title>{nameToDisplay} Notes</Title>
        }
        { annotationBlock }
        <CreateComponents>{ createComponents }</CreateComponents>
      </AnnoContainer>
    );
  }
}

AnnotationsList.contextTypes = {
  store: PropTypes.object
};

AnnotationsList.propTypes = {
  pageId: PropTypes.string.isRequired,
  loggedInUserId: PropTypes.string,
  authorUserId: PropTypes.string,
  sectionId: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const user = state.user.data || {};
  const { annotations, votePrefs } = state;
  return { user, annotations, votePrefs };
}

export default connect(mapStateToProps, {})(withRouter(AnnotationsList));




// WEBPACK FOOTER //
// ./src/components/interactive/annotation/AnnotationsList.js